const mockRecipientListsData = [
    {
        "id": 1,
        "name": "To E-Mail",
        "recipient_count": 53
    },
    {
        "id": 2,
        "name": "Newsletters",
        "recipient_count": 55
    },
    {
        "id": 3,
        "name": "VIP Customers",
        "recipient_count": 25
    },
    {
        "id": 4,
        "name": "Promo Invites",
        "recipient_count": 46
    },
    {
        "id": 5,
        "name": "Product Updates",
        "recipient_count": 17
    },
];
export default mockRecipientListsData;